import BackboneElement from '../BackboneElement';
import merge from 'lodash/merge';
import CodeableConcept from '@/fhirworks/types/CodeableConcept';
import AsNeededX from '@/fhirworks/types/AsNeededX';
import DosageDoseAndRate from '@/fhirworks/types/DosageDoseAndRate';
import DosageHold from '@/fhirworks/types/DosageHold';
import Quantity from '@/fhirworks/types/Quantity';
import Reference from '@/fhirworks/types/Reference';
import Timing from '@/fhirworks/types/Timing';

/**
 * @property {String} value
 * @property {String} comparator
 * @property {String} unit
 * @property {String} system
 * @property {String} code
 */
export default class Dosage extends BackboneElement {
    static __className = 'Dosage';

    __objectStructure = {
        sequence: Number,
        text: String,
        additionalInstruction: [CodeableConcept],
        patientInstruction: String,
        timing: Timing,
        asNeeded: AsNeededX,
        site: CodeableConcept,
        route: CodeableConcept,
        method: CodeableConcept,
        doseAndRate: [DosageDoseAndRate],

        // First-class extensions
        minimumInterval: Quantity, // FHIR Duration; Quantity is structurally identical and no Duration class exists in fhirworks.
        // A taper step's 'Continue for'. Not timing.repeat.boundsDuration: bounds[x] is a choice,
        // and a segment already spends it on boundsPeriod, which is what places it in the chain.
        stepDuration: Quantity,
        maxPerDay: Number,
        hold: DosageHold, // Presence is the hold — there is no separate held flag.
        addedBy: Reference,
        addedOn: String,
        selfAdministered: Boolean, // the exception: this window is given by the patient, not the clinic
        // Where this window's doses are given. A schedule moves without the order being rewritten:
        // a patient steps down to another program and the next segment names the new site.
        administeringLocation: Reference,
    };

    constructor(constructJson, className = 'Dosage') {
        super(constructJson, className);

        this.createAndPopulateStructure(this.__objectStructure, constructJson, this.__objectDefaults);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
